export default __webpack_public_path__ + "static/media/algorand-algo-logo.2015fd2c.svg";